import moment from "moment/moment";
import {ITrainingCommon} from "../typings/ITrainingCommon";

export const getTrainingFullName = (training: ITrainingCommon, t: any) => {
    const date = moment(training.startAt).format("YYYY-MM-DD_HH-mm");
    return training.trainings.map(x => x.user?.name ?? t("guest athlete")).join(" ") + " " +
        training.name + " " + date;
}